import {gsap} from "gsap";
import Spine = PIXI.spine.Spine;

export class ExtraFreespinAwardView extends PIXI.Container {
    private _spine: Spine | null;

    constructor() {
        super();
        this.name = "ExtraFreespinAwardView";
        this.init();
    }

    private init() {
        this.position.set(360, 360);
        this.visible = false;
    }

    public reset(): void {

        this.visible = false;
    }

    public show(): gsap.core.Timeline {
        this.position.set(360, 360);
        return new gsap.core.Timeline();
    }
}